import React from 'react';
import ReactDOM from 'react-dom';
import {connect} from 'react-redux';
import Translator from "../../helpers/Translator";
import {DOMAIN} from "../FilterContainer";
import {
    clearFilter,
    forwardTimeChange,
    forwardTimeChangeUpdate,
    forwardTimeTypeChange,
    returnTimeChange,
    returnTimeChangeUpdate,
    returnTimeTypeChange
} from "../../actions/FlightsActions";
import {bindActionCreators} from "redux";
import {registerAppliedFilter} from "../../actions/FilterGroupsActions";
import BaseFilterComponent from "./BaseFilterComponent";
import {initialState as forwardInitial} from "../../reducers/filters/ForwardTimeFilterReducer";
import {initialState as returnInitial} from "../../reducers/filters/ReturnTimeFilterReducer";
import Timer from "../../helpers/Timer";

class TimeBlock extends BaseFilterComponent {
    constructor(props) {
        super(props);
        this.filter = props.filter;
        this.name = props.name;
        const type = `${props.type}Time`;
        const initials = {
            'forward': forwardInitial,
            'return': returnInitial
        };
        const initial = initials[props.type];
        this.urlEnabled = props.urlFilters[type]
            && (props.urlFilters[type].type !== initial.type
            || props.urlFilters[type].start !== initial.start
            || props.urlFilters[type].end !== initial.end);
    }

    componentDidMount() {
        ReactDOM.findDOMNode(this.form).setAttribute('mbsc-form', true);
        ReactDOM.findDOMNode(this.autocomplete).setAttribute('autocomplete', 'off');
        ReactDOM.findDOMNode(this.autocomplete2).setAttribute('autocomplete', 'off');

        const changeActionName = `${this.props.type}TimeChange`;
        const self = this;

        this.timer = new Timer(300, () => {
            self.props[`${changeActionName}Update`]();
        });

        this.from.addEventListener('change', (e) => {
            this.props[changeActionName]({start: e.target.value});
            if (!this.timer.isRunning()) {
                this.timer.start();
            } else {
                this.timer.restart();
            }
        });

        this.to.addEventListener('change', (e) => {
            this.props[changeActionName]({end: e.target.value});
            if (!this.timer.isRunning()) {
                this.timer.start();
            } else {
                this.timer.restart();
            }
        });

        super.componentDidMount();
    }

    changeType(e) {
        const changeActionName = `${this.props.type}TimeTypeChange`;
        this.props[changeActionName](e.target.value);
    }

    isActiveTypeClass(type) {
        const timeType = `${this.props.type}TimeType`;
        return type === this.props[timeType].type ? 'active' : '';
    }

    renderLabel(value) {
        return `${value >= 10 ? value : `0${value}`}:00`;
    }

    getSliderValue(place) {
        const timeType = `${this.props.type}TimeType`;

        return this.props[timeType][place];
    }

    render() {
        this.translator = new Translator(this.props.translator, DOMAIN);

        return (
            <div>
                <div className={`card-body ${this.isApplied() ? `filter-applied` : null}`}>
                    <span className="font-weight-bold">{this.translator.trans('Time')}</span>
                    {this.renderClearFilterButton()}
                    <span className="text-muted"> ({this.props.from} - {this.props.to})</span>
                    <div className="btn-group btn-group-toggle my-3 departure-arrival" data-toggle="buttons">
                        <label className={`btn btn-light btn-sm ${this.isActiveTypeClass('departure')}`}>
                            <input type="radio" onClick={this.changeType.bind(this)} name="options" value="departure"
                                   ref={(ref) => this.autocomplete = ref}/> {this.translator.trans('Departure')}
                        </label>
                        <label className={`btn btn-light btn-sm ${this.isActiveTypeClass('arrival')}`}>
                            <input type="radio" onClick={this.changeType.bind(this)} name="options" value="arrival"
                                   ref={(ref) => this.autocomplete2 = ref}/> {this.translator.trans('Arrival')}
                        </label>
                    </div>
                    <div className="clearfix mb-2">
                        <span className="float-left">
                            <small>{this.renderLabel(this.getSliderValue('start'))}</small>
                        </span>
                        <span className="float-right">
                            <small>{this.renderLabel(this.getSliderValue('end'))}</small>
                        </span>
                    </div>
                    <div className="waavo-slider mobiscroll-refresh-element" id={`time-slider-${this.props.type}`} ref={(ref) => this.form = ref}
                         style={{display: 'none'}}>
                        <input ref={(ref) => this.from = ref} type="range"
                               value={this.getSliderValue('start')}
                               min="0" max="24"/>
                        <input ref={(ref) => this.to = ref} type="range"
                               value={this.getSliderValue('end')}
                               min="0" max="24"/>
                    </div>
                </div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        forwardTimeTypeChange,
        forwardTimeChange,
        forwardTimeChangeUpdate,
        returnTimeTypeChange,
        returnTimeChangeUpdate,
        returnTimeChange,
        registerAppliedFilter,
        clearFilter
    }, dispatch);
}

function mapStateToProps(state, ownProps) {
    return {
        translator: state.TranslationsReducer.translations,
        type: ownProps.type,
        forwardTimeType: state.ForwardTimeFilterReducer,
        returnTimeType: state.ReturnTimeFilterReducer,
        from: ownProps.from,
        to: ownProps.to,
        urlFilters: state.SocketReducer.urlFilters,
        appliedFilters: state.FilterGroupsReducer
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TimeBlock);



// WEBPACK FOOTER //
// ./src/components/filters/TimeBlock.js